import React from 'react'
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";





function RouteConfig(props) {

  const OtherComponent = React.lazy(() => import('../../main/page/root_page/RootPage'));
  return (


    <Router>

      <Routes>
        <Route exact path={"/"} element={<OtherComponent />} />
        {

          props?.routers.map((route, i) => (

            <Route key={i} exact={route.exact} path={route.path} element={<route.component />} />
          ))
        }


      </Routes>

    </Router>

  )
}





export default RouteConfig